export default "__VITE_ASSET__CYhdtLoP__"